export default {
  charts: state => state.charts || [],
}
